import { CONTACT_POINT_SYSTEM, GENDER, REGEX_EXPS } from "utils/constants";
import * as yup from "yup";

const validation = (errors) => {
  const requiredName = yup
    .string()
    .typeError(errors.REQUIRED)
    .matches(REGEX_EXPS.name, errors.INVALID_NAME)
    .required(errors.REQUIRED);
  return yup.object().shape({
    telecoms: yup.object().shape({
      [CONTACT_POINT_SYSTEM.EMAIL]: yup.object().shape({
        value: yup
          .string()
          .nullable()
          .email(errors.EMAIL)
          .required(errors.REQUIRED),
      }),
      [CONTACT_POINT_SYSTEM.PHONE]: yup.object().shape({
        value: yup
          .string()
          .typeError(errors.REQUIRED)
          .required(errors.REQUIRED)
          .test("isValid", errors.INVALID_VALUE, async function (value) {
            return new RegExp(REGEX_EXPS.internationalMobilePhone).test(
              value?.replace(/\s+/g, ""),
            );
          }),
      }),
    }),
    user: yup.object().shape({
      firstname: requiredName,
      lastname: requiredName,
      gender: yup
        .string()
        .typeError(errors.REQUIRED)
        .required(errors.REQUIRED)
        .oneOf([GENDER.MALE, GENDER.FEMALE], errors.INVALID_VALUE),
    }),
  });
};

export default validation;
